<section class="loan-detail-wrap">
  <div class="wrap-lg">
    <div class="loan-inner">
      <div class="nav-sec">
        <div class="back-nav" (click)="goToHome()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 6L9 12L15 18" stroke="#1A204B" stroke-width="1.75" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span class="nav-name">Back</span>
        </div>
      </div>
      <div class="page-head">
        <div class="head-left">
          <div class="page-title">Customize Loan Details</div>
          <div class="page-info">Help us get the best loan terms for you</div>
        </div>
      </div>
      <div class="box-wrap">
        <div class="loan-content">
          <div class="option-col">
            <label class="form-label">What is your desired loan amount?</label>
            <div class="loan-option" [ngClass]="{'active': isfullamt}" (click)="isfullamt = true">
              <div class="option-name"><span class="option-dot"></span> Full loan amount <span
                  class="lite">(₹{{getLargetFees}})</span></div>
            </div>
            <div class="loan-option " [ngClass]="{'active': !isfullamt}" (click)="isfullamt = false">
              <div class="option-name"><span class="option-dot"></span>Custom loan amount</div>
              <div class="option-input" *ngIf="!isfullamt">
                <div class="rupee-icon">₹</div>
                <input type="text" (focus)="showCustomAmtValidation = false" (blur)="showCustomAmtValidation = true"
                  class="cus-input" [maxlength]="this.largestFee.toString().length || 0" [(ngModel)]="customAmount" (input)="validateNumber($event)" />
              </div>
              <p *ngIf="!isfullamt && (customAmount < productCat.config.minLoanAmount || customAmount > largestFee)"
                class="error">{{customAmount > largestFee?'Maximum': 'Minimum'}} Loan Amount is ₹{{customAmount >
                largestFee? largestFee: productCat.config.minLoanAmount}}</p>
            </div>
          </div>
          <div class="tenure-col">
            <label class="form-label">What is your desired loan tenure?</label>
            <!-- Scenario 1 -->
            <div class="tenure-slide" *ngIf="!tenureData.length && this.processType !== '2'">
              <div class="tenure-view">
                <span class="view-box">{{value}}M</span>
              </div>
              <div class="range-slide">
                <p-slider [(ngModel)]="value" [step]="1" [min]="minTenor" [max]="maxTenor"></p-slider>
                <div class="slide-opt">
                  <span class="start">{{minTenor}} Months</span>
                  <span class="end">{{maxTenor}} Months</span>
                </div>
              </div>
            </div>
            <!-- Scenario 2 -->
            <div class="tenure-input fixed" *ngIf="tenureData && tenureData.length === 1 && this.processType !== '2'">
              <input type="text" class="cus-input" value="Loan tenure" [readOnly]="true" />
              <img src="assets/images/icons/calender.svg" alt="Calendar" class="tenure-calendar" />
              <span class="tenure-val">{{tenureData[0].tenor}}M</span>
            </div>
            <!-- Scenario 3 -->
            <div class="tenure-input cus-dropdown"
              *ngIf="tenureData && tenureData.length > 1 && this.processType !== '2'"
              (click)="openDrop('tenure_select')">
              <input type="text" class="cus-input" readonly
                [value]="selectedTebure.tenor? selectedTebure.tenor+' Months' :'Select tenure'" />
              <img src="assets/images/icons/calender.svg" alt="Calendar" class="tenure-calendar" />
              <div id="tenure_select" class="drop-content">
                <div class="drop-item" (click)="selectedTebure = tenure" *ngFor="let tenure of tenureData">
                  {{tenure.tenor}} Months</div>
              </div>
            </div>
            <!-- Scenario 4 -->
            <div class="tenure-input add-tenure" (click)="openTenurePopup()" *ngIf="processType==='2'">
              <input type="text" class="cus-input" readonly
                [value]="selectedTebure.tenor ? (selectedTebure.tenor+' Months') : 'Add tenure'" />
              <img src="assets/images/icons/calender.svg" alt="Calendar" class="tenure-calendar" />
              <span class="tenure-val" >
                <img src="assets/images/icons/add.svg" alt="Add" class="tenure-add" />
              </span>
            </div>
          </div>
          <div class="amount-col">
            <div class="amount-lab">EMI for {{this.selectedTebure.tenor || this.value}} months</div>
            <div class="amount-val"><span class="lite">₹</span>{{monthlyEMI}}</div>
          </div>
        </div>
        <div class="page-action">
          <button class="btn-primary" (click)="submit()" [disabled]="!isValid">Continue</button>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Custom tenure Select Popup-->
<p-dialog [(visible)]="tenurePopup" [modal]="true" styleClass="cus-dialog-sm cus-dialog loan-emi" [draggable]="false"
  [resizable]="false">
  <div class="tenure-select">
    <div class="dialog-title">Choose EMI plans</div>
    <div class="dialog-info">For your Easy Monthly Installments (EMI)</div>
    <div class="tenure-content">
      <div class="cus-radio">
        <div class="radio-item" (click)="isNoCostEmi = true"  *ngIf="noCostEmit.length">
          <input class="radio-input" type="radio" name="tenure-radio" id="tenure_radio_1" [checked]="isNoCostEmi" />
          <label for="tenure_radio_1">No Cost EMI</label>
        </div>
        <div class="radio-item" (click)="isNoCostEmi = false" *ngIf="standardEmi.length">
          <input class="radio-input" type="radio" name="tenure-radio" id="tenure_radio_2"  [checked]="!isNoCostEmi" />
          <label for="tenure_radio_2">Standard EMI</label>
        </div>
      </div>
      <div class="cus-table bor-radius">
        <table class="table">
          <thead>
            <tr>
              <th>Tenure (Monthly)</th>
              <th>Interest</th>
              <th>EMI</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tenure of isNoCostEmi?  noCostEmit : standardEmi" (click)="selectedTebure = tenure; tenurePopup = false"
              class="{{selectedTebure.tenor === tenure.tenor &&  selectedTebure.emi_type === tenure.emi_type ? 'emi-active':''}}">
              <td class="with-arrow ">
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none">
                  <path class="sv_fill_theme_icon" d="M16 9L0.822556 0.955336L4.0829 8.96493L0.822557 16.9553L16 9Z"
                    fill="#10D7EE" />
                </svg>
                {{tenure.tenor}}
              </td>
              <td>{{tenure.customer_roi}}%</td>
              <td>₹ {{monthlyEMICalc(tenure.customer_roi ?? 0, tenure.tenor,totalAmount)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="tenure-act"> -->
        <!-- <button class="btn-primary" (click)="tenurePopup = false" [disabled]="!selectedTebure.tenor">Continue</button> -->
      <!-- </div> -->
    </div>
  </div>
</p-dialog>